import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FiSearch,
  FiPlus,
  FiCalendar,
  FiClock,
  FiFolder,
  FiUsers,
  FiArrowRight,
  FiFilter,
  FiMonitor,
  FiLayers,
  FiX,
} from "react-icons/fi";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { EmployeeworspaceModal } from "./Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../../index.css";
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaFolder,
  FaUsers,
} from "react-icons/fa";
import "./WorkDashboardnew.css";
const WorkDashboardnew = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [searchQuery, setSearchQuery] = useState("");

  const [selectedProject, setSelectedProject] = useState(null);
  const [workspacedata, setworkspacedata] = useState([]);
  const [completed, setcompleted] = useState([]);
  const [overdue, setoverdue] = useState([]);
  const [pending, setpending] = useState([]);
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const getWorkspacedata = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
          firmid: user.firm_id,
          ownerid: user.userid,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetYourWorkspace`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setworkspacedata(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const Getcompletedtask = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
          firmid: user.firm_id,
          type: "C",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeTaskStatus`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setcompleted(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const Getoverduetask = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
          firmid: user.firm_id,
          type: "O",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeTaskStatus`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setoverdue(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const getpendingtask = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
          firmid: user.firm_id,
          type: "P",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeTaskStatus`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setpending(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    getWorkspacedata();
    Getcompletedtask();
    Getoverduetask();
    getpendingtask();
  }, []);
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(null);
  const [showAddEmployeeModal, setShowAddEmployeeModal] = useState(false);
  const handleAddEmployeeModalOpen = (workspaceId, projectId) => {
    setSelectedWorkspaceId(workspaceId);
    setSelectedProject(projectId);
    setShowAddEmployeeModal(true);
  };

  const handleAddEmployeeModalClose = () => {
    setShowAddEmployeeModal(false);
  };

  const [projectFilter, setProjectFilter] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [expandedTasks, setExpandedTasks] = useState({});
  const projectNames = [
    ...new Set(workspacedata.map((item) => item.project_name).filter(Boolean)),
  ];
  const filteredWorkspaceData = workspacedata.filter((workspace) => {
    const query = searchQuery.trim().toLowerCase();
    const matches = [
      workspace.workspace_name,
      workspace.workspce_desc,
      workspace.project_name,
      workspace.project_ownership,
      workspace.ownername,
      ...(workspace.lettersdata || []).map((employee) => employee.emp_name),
    ].some((value) =>
      String(value || "")
        .toLowerCase()
        .includes(query),
    );
    return (
      matches && (!projectFilter || workspace.project_name === projectFilter)
    );
  });

  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayImageUrl, setOverlayImageUrl] = useState(null);
  const handleImageClick = (imageUrl) => {
    setOverlayImageUrl(imageUrl);
    setShowOverlay(true);
  };
  const handleCloseOverlay = () => {
    setShowOverlay(false);
    setOverlayImageUrl(null);
  };
  const formatDate = (value) => {
    if (!value) return "—";
    const date = new Date(value);
    return Number.isNaN(date.getTime())
      ? "—"
      : date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
  };
  const assigneePhoto = (task) => {
    if (task.task_assignee_image_url) return task.task_assignee_image_url;
    const assignee = String(task.task_assignee || "")
      .trim()
      .toLowerCase();
    const employee = workspacedata
      .flatMap((workspace) => workspace.lettersdata || [])
      .find(
        (person) =>
          String(person.emp_name || "")
            .trim()
            .toLowerCase() === assignee,
      );
    return (
      employee?.image_url ||
      (assignee &&
      assignee ===
        String(user.username || "")
          .trim()
          .toLowerCase()
        ? user.profile_url
        : null)
    );
  };
  const taskPanels = [
    {
      key: "completed",
      title: "Completed Tasks",
      items: completed,
      icon: FaCheckCircle,
      tone: "green",
    },
    {
      key: "overdue",
      title: "Overdue Tasks",
      items: overdue,
      icon: FaExclamationCircle,
      tone: "red",
    },
    {
      key: "pending",
      title: "Pending Tasks",
      items: pending,
      icon: FiClock,
      tone: "orange",
    },
  ];
  const summaries = [
    {
      title: "Completed Tasks",
      count: completed.length,
      icon: FaCheckCircle,
      tone: "green",
      detail: "Tasks completed",
    },
    {
      title: "Pending Tasks",
      count: pending.length,
      icon: FiClock,
      tone: "orange",
      detail: "Awaiting completion",
    },
    {
      title: "Overdue Tasks",
      count: overdue.length,
      icon: FaExclamationCircle,
      tone: "red",
      detail: "Past their due date",
    },
    {
      title: "Active Projects",
      count: new Set(
        workspacedata
          .map((item) => item.pk_project_id || item.project_name)
          .filter(Boolean),
      ).size,
      icon: FaFolder,
      tone: "blue",
      detail: "Across your workspaces",
    },
    {
      title: "Team Spaces",
      count: workspacedata.length,
      icon: FaUsers,
      tone: "purple",
      detail: "Your workspaces",
    },
  ];

  return (
    <div className="wd-page">
      <header className="wd-header">
        <div>
          <h1>Workspace Dashboard</h1>
          <p>Track your tasks, projects and team spaces all in one place.</p>
        </div>
        <div className="wd-header-actions">
          <Link className="wd-create" to="/Employee/create-workspace">
            <FiPlus />
            Create Workspace
          </Link>
        </div>
      </header>
      <div className="wd-summaries">
        {summaries.map(({ title, count, icon: Icon, tone, detail }) => (
          <section key={title} className="wd-summary">
            <span className={`wd-icon wd-${tone}`}>
              <Icon />
            </span>
            <div>
              <h2>{title}</h2>
              <strong>{count}</strong>
              <p>{detail}</p>
            </div>
          </section>
        ))}
      </div>
      <div className="wd-task-grid">
        {taskPanels.map(({ key, title, items, icon: Icon, tone }) => (
          <section key={key} className={`wd-task-panel wd-tone-${tone}`}>
            <div className="wd-panel-heading">
              <h2>
                <span className={`wd-icon wd-${tone}`}>
                  <Icon />
                </span>
                {title}
              </h2>
              {
                <button
                  type="button"
                  onClick={() =>
                    setExpandedTasks((current) => ({
                      ...current,
                      [key]: !current[key],
                    }))
                  }
                >
                  {expandedTasks[key] ? "Show less" : "View all"}
                  <FiArrowRight />
                </button>
              }
            </div>
            <div className="wd-task-scroll">
              <table>
                <thead>
                  <tr>
                    <th>Task</th>
                    <th>Assigned By</th>
                    <th>{key === "completed" ? "End Date" : "Due Date"}</th>
                  </tr>
                </thead>
                <tbody>
                  {items.length ? (
                    (expandedTasks[key] ? items : items.slice(0, 4)).map(
                      (item, index) => (
                        <tr key={item.pk_task_id || index}>
                          <td>
                            <span className="wd-task-name">
                              <i />
                              {item.taskname || "—"}
                            </span>
                          </td>
                          <td>
                            <span className="wd-assignee">
                              <span className="wd-person">
                                {assigneePhoto(item) ? (
                                  <img src={assigneePhoto(item)} alt="" />
                                ) : (
                                  String(item.task_assignee || "?")
                                    .charAt(0)
                                    .toUpperCase()
                                )}
                              </span>
                              {item.task_assignee || "—"}
                            </span>
                          </td>
                          <td>
                            {formatDate(
                              key === "completed"
                                ? item.task_completeddate ||
                                    item.completed_date ||
                                    item.task_enddate
                                : item.task_enddate,
                            )}
                          </td>
                        </tr>
                      ),
                    )
                  ) : (
                    <tr>
                      <td colSpan={3} className="wd-empty">
                        No {key} tasks
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>
        ))}
      </div>
      <section className="wd-workspaces">
        <div className="wd-workspace-header">
          <div className="wd-workspace-title">
            <span className="wd-icon wd-blue">
              <FiFolder />
            </span>
            <div>
              <h2>Workspaces &amp; Projects</h2>
              <p>
                Manage and access all your workspaces, projects and team spaces.
              </p>
            </div>
          </div>
          <div className="wd-table-tools">
            <label className="wd-search">
              <FiSearch />
              <input
                aria-label="Search workspaces"
                placeholder="Search workspaces..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </label>
            <button
              type="button"
              className={`wd-filter ${projectFilter ? "is-active" : ""}`}
              aria-expanded={showFilters}
              onClick={() => setShowFilters(!showFilters)}
            >
              <FiFilter />
              Filter
            </button>
          </div>
        </div>
        {showFilters && (
          <div className="wd-filter-bar">
            <label htmlFor="wd-project-filter">Project</label>
            <select
              id="wd-project-filter"
              value={projectFilter}
              onChange={(event) => setProjectFilter(event.target.value)}
            >
              <option value="">All projects</option>
              {projectNames.map((name) => (
                <option key={name} value={name}>
                  {name}
                </option>
              ))}
            </select>
            {projectFilter && (
              <button type="button" onClick={() => setProjectFilter("")}>
                Clear filter
              </button>
            )}
          </div>
        )}
        <div className="wd-table-scroll">
          <table className="wd-workspace-table">
            <thead>
              <tr>
                <th>Workspace / Project</th>
                <th>Description</th>
                <th>Project</th>
                <th>Team</th>
                <th>Team Size</th>
                {/* <th>Due Date</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredWorkspaceData.length ? (
                [...filteredWorkspaceData].reverse().map((item, index) => (
                  <tr key={item.pk_work_id || index}>
                    <td>
                      <div className="wd-workspace-name">
                        <span
                          className={`wd-icon wd-${["blue", "green", "purple", "orange", "teal", "red"][index % 6]}`}
                        >
                          {index % 2 ? <FiLayers /> : <FiMonitor />}
                        </span>
                        <div>
                          <strong>{item.workspace_name}</strong>
                          <small>
                            WS-
                            {String(item.pk_work_id || index + 1).padStart(
                              3,
                              "0",
                            )}
                          </small>
                        </div>
                      </div>
                    </td>
                    <td className="wd-description">
                      {item.workspce_desc || "—"}
                    </td>
                    <td>{item.project_name || "—"}</td>
                    <td>
                      <div className="wd-team">
                        {(item.lettersdata || [])
                          .slice(0, 3)
                          .map((employee, employeeIndex) => (
                            <button
                              type="button"
                              key={employee.emp_id || employeeIndex}
                              title={employee.emp_name}
                              aria-label={
                                employee.image_url
                                  ? `View ${employee.emp_name}'s photo`
                                  : employee.emp_name
                              }
                              disabled={!employee.image_url}
                              onClick={() =>
                                handleImageClick(employee.image_url)
                              }
                              style={{
                                backgroundColor: item.colourcode || "#4f87c9",
                              }}
                            >
                              {employee.image_url ? (
                                <img
                                  src={employee.image_url}
                                  alt={employee.emp_name}
                                />
                              ) : (
                                employee.employee_first_letter ||
                                String(employee.emp_name || "?").charAt(0)
                              )}
                            </button>
                          ))}
                        {(item.lettersdata || []).length > 3 && (
                          <span
                            className="wd-team-more"
                            title={(item.lettersdata || [])
                              .slice(3)
                              .map((employee) => employee.emp_name)
                              .join(", ")}
                          >
                            +{item.lettersdata.length - 3}
                          </span>
                        )}
                        {!(item.lettersdata || []).length && (
                          <span className="wd-muted">No members</span>
                        )}
                      </div>
                    </td>
                    <td className="wd-nowrap">{item.teamsize || "—"}</td>
                    {/* <td className="wd-nowrap">
                      <span className="wd-date">
                        <FiCalendar />
                        {formatDate(
                          item.due_date ||
                            item.workspace_enddate ||
                            item.enddate,
                        )}
                      </span>
                    </td> */}
                    <td>
                      <div className="wd-row-actions">
                        <Link
                          className="wd-open"
                          to="/Employee/Employeeworkspace"
                          onClick={() =>
                            sessionStorage.setItem(
                              "property",
                              JSON.stringify(item),
                            )
                          }
                        >
                          Open
                          <FiArrowRight />
                        </Link>
                        <details className="wd-row-menu">
                          <summary
                            aria-label={`Actions for ${item.workspace_name}`}
                          >
                            •••
                          </summary>
                          <button
                            className="wd-assign"
                            type="button"
                            onClick={() =>
                              handleAddEmployeeModalOpen(
                                item.pk_work_id,
                                item.pk_project_id,
                              )
                            }
                          >
                            <FiUsers />
                            Assign Employee
                          </button>
                        </details>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="wd-empty">
                    {searchQuery || projectFilter
                      ? "No workspaces match your filters."
                      : "No workspaces found. Create a workspace to get started."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
      {showOverlay && overlayImageUrl && (
        <div
          className="wd-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Employee photo"
          onClick={handleCloseOverlay}
        >
          <button
            type="button"
            aria-label="Close photo"
            onClick={handleCloseOverlay}
          >
            <FiX />
          </button>
          <img src={overlayImageUrl} alt="Employee profile" />
        </div>
      )}
      <EmployeeworspaceModal
        isOpen={showAddEmployeeModal}
        onClose={handleAddEmployeeModalClose}
        selectedWorkspaceId={selectedWorkspaceId}
        getWorkspacedata={getWorkspacedata}
        selectedProject={selectedProject}
      />
    </div>
  );
};

export default WorkDashboardnew;
